<template>
	<!-- modal reset password form start -->
  <div v-if="modal" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-medium">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title mb-3">Update your email</p>	
        <p class="text-center">To update your email, you will need to send and enter a verification code to confirm changes.</p>
      </header>
      <section class="modal-card-body ph20">
        <form class="text-center change-email-wrap">
          <div class="field-group">
            <div class="field">

              <div class="control">
                <validation-provider
                    name="new email"
                    ref="email"
                    rules="required|email"
                    vid="email"
                  >
                  <template #default="{ errors }">
                    <div class="input-field-with-button">
                      <input
                        name="new email"
                        class="input"
                        v-model="form.email"
                        type="email"
                        placeholder="Enter New Email"
                      />
                      <button @click.prevent="sendEmailUpdateCode()" class="button is-primary send-email-change-code">Send Code</button>
                    </div>
                    <span class="validation-error" v-html="errors[0]"></span>
                  </template>
                </validation-provider>
              </div>

              <div class="field">
                <div class="control">
                  <validation-provider
                      name="code"
                      ref="code"
                      rules="required"
                      vid="code"
                  >
                    <template #default="{ errors }">
                      <input
                        name="Code"
                        class="input"
                        v-model="form.code"
                        type="email"
                        placeholder="Enter Verification Code"
                      />
                      <span class="validation-error" v-html="errors[0]"></span>
                    </template>
                  </validation-provider>
                </div>
              </div>

            </div>
          </div>
        </form>
      <!-- form end -->
      </section>
      
      <footer class="modal-card-foot">
        <button @click="updateEmail()" class="button is-large is-primary is-full-width">Update Email</button>
      </footer>
    </div>
  </div>
	<!-- modal  reset password  form end -->
</template>

<script>
import Env from '@/env';
import Helpers from '@/Components/Helpers/Helpers';
import UserApis from '@/Components/Controllers/UserApis';
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  data() {
    return {
      modal: false,
      form: {
        email : "",
        code: "",
      }
    };
  },
  computed: {
    ...mapGetters({
      vg_selectedStore: "location/selected", 
      vg_businessProfile: "businessprofile/detail", 
    })
  },

  mounted() {
    bus.$on('show-modal-change-email', (payload) => {
      this.modal = payload;
    })
  },

  beforeDestroy() {
    bus.$off('show-modal-change-email');
  },

  methods: {
    /**
     * send email update code 
     */
    async sendEmailUpdateCode() {
      let validation = await Helpers.validateRefs(this, ['email']);
      if( validation ) {
        this.va_spinner(true);
        let res = await UserApis.sendEmailVerificationCode({
          email: this.form.email,
          // Extra need to pass
          business_id: this.vg_businessProfile.id,
          business_name: this.vg_businessProfile.name,
          business_slug: this.$route.params.business_slug,
          logo_url: (this.vg_businessProfile && this.vg_businessProfile.branding && this.vg_businessProfile.branding.logo_url) ? this.vg_businessProfile.branding.logo_url : '',
          location_id: this.vg_selectedStore.id ? this.vg_selectedStore.id: '',
          location_slug: this.vg_selectedStore.slug ? this.vg_selectedStore.slug :'',
        });
        this.va_spinner(false);
        this.va_snackbar({
          type: res.status == 200 ? 'success' : 'warning',
          message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        });
      }
    },

    /**
     * Update password
     */
    async updateEmail() {
      let validation = await Helpers.validateRefs(this, ['email', 'code']);
      if( validation ) {
        this.va_spinner(true)
        let res = await UserApis.changeEmail(this.form);
        this.va_spinner(false)
        if(res.status == 200){
          // now assign values
          this.vm_mutateUserDetailItem({ 
            key: 'email', 
            value: res.data.payload.email
          })
          this.closeModal();
        } 
        this.va_snackbar({
          type: res.status == 200 ? 'success' : 'warning',
          message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        });
      }
    },

    closeModal() {
      this.form = Helpers.setObjValueEmpty(this.form);
      this.modal = false;
    },
    ...mapMutations({
      vm_mutateUserDetailItem: "MUTATE_USER_DETAILS_BY_KEY",
    }),
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })
  },
};
</script>